import type { FunctionComponent } from 'react';

import {
  DesktopLayoutDefault,
  DesktopLayoutDefaultContent,
  DesktopLayoutDefaultContentHeader,
} from '@kanda-libs/ks-design-library';

import PartnerProfile from './PartnerProfile';

import PartnerBanner from '../PartnerBanner';
import PartnerReferrals from '../PartnerReferrals';

const PartnerLayout: FunctionComponent = function () {
  return (
    <DesktopLayoutDefault>
      <DesktopLayoutDefaultContentHeader>
        <PartnerBanner />
      </DesktopLayoutDefaultContentHeader>
      <DesktopLayoutDefaultContent>
        <PartnerProfile />
        <PartnerReferrals />
      </DesktopLayoutDefaultContent>
    </DesktopLayoutDefault>
  );
};

export default PartnerLayout;
